<template>
  <div>
    <div class="row">
      <div
        class="
          col-xl-6 col-lg-6 col-md-6 col-sm-7 col-8
          d-flex
          align-items-center
        "
      >
        <h1 class="title-pages mb-0">RECEITA MÉDICA</h1>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-4 text-right">
        <v-btn @click="$bvModal.show('imprimir')" class="btn-filter m-1"
          ><i
            :class="[
              'fas fa-filter text-twenty',
              width < 600 ? 'mr-0' : 'mr-2',
            ]"
          ></i>
          <span v-if="width > 600">FILTRAR</span></v-btn
        >

        <b-modal
          no-close-on-backdrop
          centered
          hide-header-close
          hide-footer
          id="imprimir"
          title="FILTRAR"
        >
          <b-overlay :show="loadingGroupPrescriptionMedicines" opacity="0.99">
            <div class="row">
              <div class="col-xl-12 pt-0">
                <h6 class="worksansr upper-text">Prescrição</h6>
                <select
                  v-if="group_prescription_medicines.length > 0"
                  v-model="group_prescription_medicine_id"
                  class="form-control"
                >
                  <option value>SELECIONE...</option>
                  <option
                    v-for="value in group_prescription_medicines"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{
                      `${formatDate(value.start_date, false)} - ${formatDate(
                        value.end_date,
                        false
                      )}`
                    }}
                    -
                    {{ handleTypeGroupPrescription(value.type) }}
                  </option>
                </select>
              </div>
            </div>
          </b-overlay>

          <h6
            class="text-center p-1"
            v-if="group_prescription_medicines.length == 0"
          >
            0 Prescrições ativas!
          </h6>

          <ErrorsMessages :errors="errors" />

          <b-button class="btn-cancel m-1" @click="$bvModal.hide('imprimir')"
            >CANCELAR</b-button
          >
          <v-btn
            v-if="group_prescription_medicines.length > 0"
            class="btn-filter-sidebar float-right"
            @click="handleFilter"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
        </b-modal>
      </div>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
      <b-overlay :show="loading" opacity="0.99">
        <div
          class="row p-5 v-clean d-flex justify-content-center"
          v-if="group_of_medicines.length == 0"
        >
          <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
        </div>
        <div
          class="row border-recipe"
          v-if="group_prescription_medicine.id && group_of_medicines.length > 0"
        >
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6 class="mb-0 upper-text color-black check-text-center">
              Prescrição Médica -
              {{
                handleTypeGroupPrescription(group_prescription_medicine.type)
              }}
              - Validade
              <strong>{{
                formatDate(group_prescription_medicine.start_date, false)
              }}</strong>
              até
              <strong>{{
                formatDate(group_prescription_medicine.end_date, false)
              }}</strong>
            </h6>
          </div>
        </div>
        <div
          class="row bg-white border mb-3 radius-border"
          v-for="group_of_medicine in group_of_medicines"
          :key="group_of_medicine.recipe.id"
        >
          <b-modal
            size="xl"
            no-close-on-backdrop
            hide-footer
            :id="`modalPrintAll-${group_of_medicine.recipe.id}`"
            title="IMPRIMIR"
          >
            <ViewRecipe
              :user="user"
              :client="client"
              :resident="resident"
              :doctors="doctors"
              :group_prescription_medicine="group_prescription_medicine"
              :medicines_print="medicines_print"
            />
          </b-modal>
          <div class="col-xl-6 col-lg-6 col-md-5 col-sm-12 col-12">
            <h4 class="text-five mb-0 pt-2 check-text-center">
              {{ group_of_medicine.recipe.name }}
            </h4>
          </div>
          <div
            class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12 check-text-right"
          >
            <v-btn
              :disabled="
                medicines_print.length > 0 &&
                medicines_print[0].recipe_id == group_of_medicine.recipe.id
                  ? false
                  : true
              "
              @click="handlePrintAll(group_of_medicine.recipe.id)"
              class="btn-print m-1"
              ><i class="fas fa-print text-twenty mr-2"></i>IMPRIMIR
            </v-btn>
          </div>
          <div class="col-xl-12 pt-0 pb-0 bg-light">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                @click="
                  handleSelectAll(
                    $event,
                    group_of_medicine.recipe.id,
                    group_of_medicine.recipe.name,
                    group_of_medicine.medicines
                  )
                "
              />
              <label class="form-check-label text-twelve">
                SELECIONAR TODOS
              </label>
            </div>
          </div>
          <div
            class="
              col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
              border-bottom
              pb-0
              pt-0
            "
            v-for="(medicine, key) in group_of_medicine.medicines"
            :key="key"
          >
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-1">
                <div class="form-check">
                  <input
                    class="form-check-input check-input-medicine"
                    type="checkbox"
                    :id="`medicine-${group_of_medicine.recipe.id}-${medicine.id}`"
                    :ref="`medicine-${group_of_medicine.recipe.id}-${medicine.id}`"
                    :data-recipe_id="group_of_medicine.recipe.id"
                    @input="
                      handleCheckbox(
                        group_of_medicine.recipe.id,
                        group_of_medicine.recipe.name,
                        group_of_medicine.medicines
                      )
                    "
                  />
                  <div
                    :for="`medicine-${group_of_medicine.recipe.id}-${medicine.id}`"
                  >
                    <h6 class="color-black">{{ medicine.name }}</h6>
                    <h6 class="legends worksansr">
                      {{ medicine.active_ingredient_name }}
                    </h6>
                    <h6
                      class="upper-text legends"
                      v-if="handleMessageRecipe(group_of_medicine.recipe.id)"
                    >
                      <i class="fas fa-exclamation-circle"></i>
                      {{ handleMessageRecipe(group_of_medicine.recipe.id) }}
                    </h6>
                    <h6 class="legends worksansr" v-if="medicine.instruction">
                      {{ medicine.instruction }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
                  pb-1
                  check-text-center
                "
              >
                <h6 v-if="medicine.frequency == 'EVENTUAL'" class="mb-0">
                  EVENTUAL
                </h6>
                <h6 class="mb-0" v-if="medicine.frequency == 'SEMANAL'">
                  Dias da semana:
                  {{ medicine.dom && "DOM" }}
                  {{ medicine.seg && "SEG" }}
                  {{ medicine.ter && "TER" }}
                  {{ medicine.qua && "QUA" }}
                  {{ medicine.qui && "QUI" }}
                  {{ medicine.sex && "SEX" }}
                  {{ medicine.sab && "SAB" }}
                </h6>
                <h6
                  class="mb-0 worksansr"
                  v-if="
                    medicine.medicine_amount_of_times_name &&
                    medicine.medicine_amount_of_times_type != 'SHIFTS'
                  "
                >
                  {{ medicine.medicine_amount_of_times_name }}:
                  <span
                    v-if="
                      medicine.medicine_amount_of_times_type == 'DAY' ||
                      medicine.frequency == 'EVENTUAL'
                    "
                  >
                    {{
                      `${
                        medicine.drops
                          ? `${medicine.drops} GOTA(S)`
                          : medicine.ui
                          ? `${medicine.ui} UI`
                          : medicine.quantity
                      } ${
                        medicine.drops
                          ? ""
                          : medicine.ui
                          ? ""
                          : `- ${medicine.unit_of_measurement_abbreviation}(S)`
                      }`
                    }}
                  </span>
                </h6>
                <div
                  class="
                    col-xl-4 col-lg-7 col-md-12 col-sm-12 col-12
                    v-clean
                    mt-1
                    mb-1
                  "
                  v-if="medicine.medicine_amount_of_times_type == 'SHIFTS'"
                >
                  <div class="row">
                    <div
                      class="
                        col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                        pt-0
                        pb-0
                      "
                    >
                      <h6 class="mb-0">TURNO</h6>
                    </div>
                    <div
                      class="
                        col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                        pt-0
                        pb-0
                      "
                    >
                      <h6 class="mb-0">QUANTIDADE</h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.dawn && medicine.dawn_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">MADRUGADA</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_dawn_quantity
                            ? `${medicine.drops_dawn_quantity} GOTA(S)`
                            : medicine.ui_dawn_quantity
                            ? `${medicine.ui_dawn_quantity} UI`
                            : medicine.dawn_quantity
                        }}
                        {{
                          medicine.drops_dawn_quantity
                            ? ""
                            : medicine.ui_dawn_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.morning && medicine.morning_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">MANHÃ</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_morning_quantity
                            ? `${medicine.drops_morning_quantity} GOTA(S)`
                            : medicine.ui_morning_quantity
                            ? `${medicine.ui_morning_quantity} UI`
                            : medicine.morning_quantity
                        }}
                        {{
                          medicine.drops_morning_quantity
                            ? ""
                            : medicine.ui_morning_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.afternoon && medicine.afternoon_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">TARDE</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_afternoon_quantity
                            ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                            : medicine.ui_afternoon_quantity
                            ? `${medicine.ui_afternoon_quantity} UI`
                            : medicine.afternoon_quantity
                        }}
                        {{
                          medicine.drops_afternoon_quantity
                            ? ""
                            : medicine.ui_afternoon_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.night && medicine.night_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="worksansr mb-0 legends">NOITE</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_night_quantity
                            ? `${medicine.drops_night_quantity} GOTA(S)`
                            : medicine.ui_night_quantity
                            ? `${medicine.ui_night_quantity} UI`
                            : medicine.night_quantity
                        }}
                        {{
                          medicine.drops_night_quantity
                            ? ""
                            : medicine.ui_night_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.shift_5 && medicine.shift_5_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="worksansr mb-0 legends">5º</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_shift_5_quantity
                            ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                            : medicine.ui_shift_5_quantity
                            ? `${medicine.ui_shift_5_quantity} UI`
                            : medicine.shift_5_quantity
                        }}
                        {{
                          medicine.drops_shift_5_quantity
                            ? ""
                            : medicine.ui_shift_5_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.shift_6 && medicine.shift_6_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="worksansr mb-0 legends">6º</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_shift_6_quantity
                            ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                            : medicine.ui_shift_6_quantity
                            ? `${medicine.ui_shift_6_quantity} UI`
                            : medicine.shift_6_quantity
                        }}
                        {{
                          medicine.drops_shift_6_quantity
                            ? ""
                            : medicine.ui_shift_6_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.shift_7 && medicine.shift_7_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="worksansr mb-0 legends">7º</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_shift_7_quantity
                            ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                            : medicine.ui_shift_7_quantity
                            ? `${medicine.ui_shift_7_quantity} UI`
                            : medicine.shift_7_quantity
                        }}
                        {{
                          medicine.drops_shift_7_quantity
                            ? ""
                            : medicine.ui_shift_7_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="medicine.shift_8 && medicine.shift_8_quantity"
                  >
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="worksansr mb-0 legends">8º</h6>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0">
                      <h6 class="mb-0 worksansr legends">
                        {{
                          medicine.drops_shift_8_quantity
                            ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                            : medicine.ui_shift_8_quantity
                            ? `${medicine.ui_shift_8_quantity} UI`
                            : medicine.shift_8_quantity
                        }}
                        {{
                          medicine.drops_shift_8_quantity
                            ? ""
                            : medicine.ui_shift_8_quantity
                            ? ""
                            : `${medicine.unit_of_measurement_abbreviation}(S)`
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
                <h6>
                  VIA DE ADMINISTRAÇÃO -
                  {{ medicine.route_of_administration_name }}
                </h6>
                <h6
                  v-if="
                    medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'
                  "
                  class="btn-pendent inline-display"
                >
                  CONTROLE ESPECIAL
                </h6>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";

import routes from "../../../routes";

import ViewRecipe from "../Recipe/View";

import ErrorsMessages from "../../Components/ErrorsMessages";

import { formatDate } from "../../../lib/format";

import { userData } from "../../../lib/functions";

export default {
  name: "Recipe",
  components: {
    ViewRecipe,
    ErrorsMessages,
  },
  props: {
    resident: Object,
  },
  data() {
    return {
      resident_id: "",
      user: {},
      client: {},
      group_prescription_medicine_id: "",
      group_prescription_medicines: [],
      group_prescription_medicine: {},
      group_of_medicines: [],
      medicines_print: [],
      doctors: [],
      errors: [],
      isActiveFilter: false,
      checkbox: false,
      loading: false,
      width: window.screen.width,
      loadingGroupPrescriptionMedicines: false,
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  methods: {
    formatDate,
    handleTypeGroupPrescription(type) {
      if (type == "LONGO_PRAZO") {
        return "LONGO PRAZO";
      }

      return "NORMAL";
    },
    handleOnResize() {
      this.width = window.innerWidth;
    },
    handleMessageRecipe(recipe_id) {
      const A_AMARELA = 1;
      const B_AZUL = 2;
      const CONTROLE_ESPECIAL_2_VIAS = 3;
      const RECEITA_SEM_RETENCAO = 4;
      const RECEITA_COMUM = 5;

      if (recipe_id == A_AMARELA) {
        return "Impressão não tem validade!";
      }

      if (recipe_id == B_AZUL) {
        return "Impressão não tem validade!";
      }

      if (recipe_id == CONTROLE_ESPECIAL_2_VIAS) {
        return null;
      }

      if (recipe_id == RECEITA_SEM_RETENCAO) {
        return;
      }

      if (recipe_id == RECEITA_COMUM) {
        return;
      }
    },
    handleCheckbox(id, recipe_name, medicines) {
      let checkboxs = document.querySelectorAll(".check-input-medicine");

      let medicines_print = [];
      let medicines_id = [];

      for (let checkbox of checkboxs) {
        if (checkbox.dataset.recipe_id == id) {
          if (checkbox.checked) {
            medicines_id.push(checkbox.id);
          }
        } else {
          checkbox.checked = false;
        }
      }

      for (let medicine_id of medicines_id) {
        for (let medicine of medicines) {
          if (`medicine-${id}-${medicine.id}` == medicine_id) {
            medicine.recipe_id = id;
            medicine.recipe_name = recipe_name;
            medicines_print.push(medicine);
          }
        }
      }

      this.medicines_print = medicines_print;
    },
    handleSelectAll(event, id, recipe_name, medicines) {
      let checkboxs = document.querySelectorAll(".check-input-medicine");

      for (let checkbox of checkboxs) {
        if (event.target.checked) {
          if (checkbox.dataset.recipe_id == id) {
            checkbox.checked = true;
          } else {
            checkbox.checked = false;
          }
        } else {
          checkbox.checked = false;
        }
      }

      let medicines_print = [];
      let medicines_id = [];

      for (let checkbox of checkboxs) {
        if (checkbox.dataset.recipe_id == id) {
          if (checkbox.checked) {
            medicines_id.push(checkbox.id);
          }
        }
      }

      for (let medicine_id of medicines_id) {
        for (let medicine of medicines) {
          if (`medicine-${id}-${medicine.id}` == medicine_id) {
            medicine.recipe_id = id;
            medicine.recipe_name = recipe_name;
            medicines_print.push(medicine);
          }
        }
      }

      this.medicines_print = medicines_print;
    },
    handlePrintAll(id) {
      this.$bvModal.show(`modalPrintAll-${id}`);
    },
    handleChangeGroupPrescriptionMedicine(id) {
      let { group_prescription_medicines } = this;

      for (let group_prescription_medicine of group_prescription_medicines) {
        if (id == group_prescription_medicine.id) {
          this.group_prescription_medicine = group_prescription_medicine;
        }
      }
    },
    handleFilter() {
      this.get();
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { user } = userData();

      this.user = user;

      await this.getGroupPrescriptionMedicines();
      await this.get();
      await this.getClient();
      await this.getUsersDoctor();
    },
    async getGroupPrescriptionMedicines() {
      try {
        this.loadingGroupPrescriptionMedicines = true;

        const { resident_id } = this;

        let params = {
          resident_id,
        };

        const response = await api.get(
          "/rest-home/resident/doctor-recipe/group-prescription-medicines",
          {
            params,
          }
        );

        const { error, errors, group_prescription_medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          if (group_prescription_medicines.length > 0) {
            this.group_prescription_medicine_id =
              group_prescription_medicines[0].id;
            this.group_prescription_medicine = group_prescription_medicines;
          }
          this.group_prescription_medicines = group_prescription_medicines;
        }

        this.loadingGroupPrescriptionMedicines = false;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;

        const { group_prescription_medicine_id, resident_id } = this;

        if (!group_prescription_medicine_id) {
          this.errors = [
            { id: this.errors, message: "Selecione a prescrição" },
          ];
          this.loading = false;
          return;
        }

        let params = {
          group_prescription_medicine_id,
          resident_id,
        };

        const response = await api.get(
          "/rest-home/resident/doctor-recipe/medicines",
          {
            params,
          }
        );

        const { error, errors, group_of_medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("imprimir");
          this.isActiveFilter = false;
          this.group_of_medicines = group_of_medicines;
          this.handleChangeGroupPrescriptionMedicine(
            group_prescription_medicine_id
          );
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getClient() {
      try {
        const response = await api.get("/rest-home/path");

        const { error, errors, client } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.client = client;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getUsersDoctor() {
      try {
        const response = await api.get("/rest-home/user-doctors");

        const { error, errors, doctors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.doctors = doctors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
